export const filterHttp = (value: string) => {
  if(!value || typeof value != 'string') return value
  return value.replace('http://', 'https://')
}
